import StatusTag from '@components/status-tag';
import styled from '@emotion/styled';

export const SadaRemoteStatusTag = styled(StatusTag)``;
